import React, { useEffect, useRef } from 'react';
import { MdStorefront, MdSubscriptions, MdPercent } from 'react-icons/md';
import './RevenueModel.css';

const revenues = [
  {
    icon: <MdStorefront />,
    title: 'Store Onboarding Fee',
    desc: 'A one-time setup fee charged when a new store joins the Pointfinity network.',
    color: '#1f78b9',
  },
  {
    icon: <MdSubscriptions />,
    title: 'Monthly / Yearly Subscriptions',
    desc: 'Recurring subscription plans from $19/mo to $99/mo based on store count and features.',
    color: '#00c853',
  },
  {
    icon: <MdPercent />,
    title: '2–3% Commission on Redemptions',
    desc: 'A small percentage commission is charged on every successful point redemption transaction.',
    color: '#a855f7',
  },
];

export default function RevenueModel() {
  const ref = useRef(null);

  useEffect(() => {
    const els = ref.current?.querySelectorAll('.reveal');
    if (!els) return;
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('revealed'); observer.unobserve(e.target); } }),
      { threshold: 0.1 }
    );
    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="revenue" id="revenue" ref={ref}>
      <div className="revenue__bg" />
      <div className="container text-center">
        <span className="section-label reveal">Revenue Model</span>
        <h2 className="section-title reveal" style={{ transitionDelay: '0.05s' }}>
          How Pointfinity Generates Revenue
        </h2>
        <p className="section-subtitle reveal" style={{ transitionDelay: '0.1s' }}>
          A sustainable, multi-stream revenue model built for long-term growth.
        </p>
        <div className="revenue__grid">
          {revenues.map((r, i) => (
            <div
              key={r.title}
              className="revenue-card reveal"
              style={{ transitionDelay: `${0.1 + i * 0.1}s` }}
            >
              <div className="revenue-card__icon" style={{ background: r.color + '15', color: r.color }}>
                {r.icon}
              </div>
              <h3>{r.title}</h3>
              <p>{r.desc}</p>
              <div className="revenue-card__bar" style={{ background: r.color }} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
